export default __webpack_public_path__ + "static/media/metycle.3c6b014a.png";